import { render, staticRenderFns } from "./defasagem.vue?vue&type=template&id=06938b4c"
import script from "./defasagem.vue?vue&type=script&lang=js"
export * from "./defasagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports